import React from 'react';
import { FormattedMessage } from 'react-intl';
import config from 'appconfig';
import { StyledLink } from '../StyledComponents';
import { StyledPipe } from './StyledPipe';

export const BuyLink = ({ productKey }: { productKey: string }) => (
  <>
    <StyledLink href={`${config.root}/product/${productKey}`} data-cy="actions-section-buy-button">
      <FormattedMessage id="mac.licenses.buy" defaultMessage="Buy" />
    </StyledLink>
    <StyledPipe />
  </>
);
